import { Routes, RouterModule } from '@angular/router';
import { CalendarComponent } from './calendar.component';
import { AuthguardService } from '../authguard.service';
import { ListCalendarComponent } from './list-calendar/list-calendar.component';
import { EditCalendarComponent } from './edit-calendar/edit-calendar.component';
import { CalendarCalendarComponent } from './calendar-calendar/calendar-calendar.component';
import { ModuleWithProviders } from '@angular/core';

export const calendarRoutes: Routes = [
    {
        path: 'calendar',
        component: CalendarComponent,
        canActivate: [AuthguardService], // comment out for testing during development
        children: [
            {path: '',
                redirectTo: 'list',
                pathMatch: 'full'},
            {path: 'new',
                component: EditCalendarComponent},
            {path: 'list',
                component: ListCalendarComponent},
            {path: 'edit/:id',
                component: EditCalendarComponent},
            {path: 'calendar',
                component: CalendarCalendarComponent}
        ]
    }
];



// WEBPACK FOOTER //
// ./src/app/calendar/calendar.routes.ts